import { useEffect } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import AnalyticsPage from "../AnalyticsPage";
import InsightsPage from "../InsightsPage";
import NexusSurfaceShell from "./NexusSurfaceShell";
import { ROUTES } from "../routes";
import { LensOperationsIcon, LensPerformanceIcon } from "./surfaceIcons";

const LENSES = [
  {
    id: "operations",
    label: "Operations",
    desc: "Funnel · drop-off · participants",
    icon: <LensOperationsIcon />,
  },
  {
    id: "performance",
    label: "Performance",
    desc: "Scores · pillars · compare",
    icon: <LensPerformanceIcon />,
  },
];

export default function PortfolioPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const lens = searchParams.get("lens") === "performance" ? "performance" : "operations";
  const { setAdminAssistantContext } = useOutletContext() || {};

  const setLens = (id) => {
    setSearchParams(id === "operations" ? {} : { lens: id });
  };

  useEffect(() => {
    setAdminAssistantContext?.({
      page: lens === "performance" ? "insights" : "analytics",
      surface: "portfolio",
      currentRoute: `${ROUTES.portfolio}${lens === "performance" ? "?lens=performance" : ""}`,
      scope: {
        label: "Portfolio Intelligence",
        text:
          lens === "performance"
            ? "Company scores, pillar analysis, compare and focus"
            : "Operational funnel, completion trends, participant pipeline",
      },
      activeLens: lens,
    });
    return () => setAdminAssistantContext?.(null);
  }, [lens, setAdminAssistantContext]);

  return (
    <NexusSurfaceShell
      surfaceId="portfolio"
      eyebrow="Portfolio Intelligence"
      title={lens === "performance" ? "Performance lens" : "Operations lens"}
      subtitle={
        lens === "performance"
          ? "Resilience scores, pillar breakdowns, and cohort comparison across your portfolio."
          : "Invite funnel, assessment completion, drop-off analytics, and live participant pipeline."
      }
      lenses={LENSES}
      activeLens={lens}
      onLensChange={setLens}
    >
      {lens === "operations" ? <AnalyticsPage embedded /> : <InsightsPage embedded />}
    </NexusSurfaceShell>
  );
}
